import { application } from "./application"

import VariantSelectorController from "./variant_selector_controller"
application.register("variant-selector", VariantSelectorController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import CartPageController from "./cart_page_controller"
application.register("cart-page", CartPageController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import AuthFormController from "./auth_form_controller"
application.register("auth-form", AuthFormController)

import AccountFormController from "./account_form_controller"
application.register("account-form", AccountFormController)
